export default __webpack_public_path__ + "static/media/nftportplantbase.c04a1ef6.png";